/** Dates and numbers, written the same way on every card. */

const day = (iso: string) => {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const longDate = (iso: string) =>
  day(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
export const shortDate = (iso: string) => day(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" });

/** The period's last day: its end date is the first day after it. */
export const lastDay = (iso: string) => {
  const d = day(iso);
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const hourLabel = (hour: number) => `${hour % 12 === 0 ? 12 : hour % 12} ${hour < 12 ? "am" : "pm"}`;
export const pct = (fraction: number) => {
  const percent = fraction * 100;
  return percent < 10 ? `${percent.toFixed(1)}%` : `${Math.round(percent)}%`;
};
export const count = (n: number) => n.toLocaleString("en-US");
